// src/HomePage/Game/FolkGame/OAnQuan/OAnQuanLobby.js
import React, { useState } from 'react';
import './OAnQuanLobby.css';

const OAnQuanLobby = ({
  rooms,
  isLoading,
  currentUser,
  onCreateRoom,
  onJoinRoom,
  onQuickMatch,
  onPlayWithBot,
  onBackToPortal,
  errorMessage,
  onClearError
}) => {
  const [filter, setFilter] = useState('all');
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showBotModal, setShowBotModal] = useState(false);
  const [roomNameInput, setRoomNameInput] = useState('');
  const [passwordInput, setPasswordInput] = useState('');
  const [targetPassRoom, setTargetPassRoom] = useState(null);
  const [joinPasswordInput, setJoinPasswordInput] = useState('');

  const getPlayerName = (player) => {
    if (!player) return '';
    const holy = player.holyName ? `${player.holyName} ` : '';
    const full = player.fullName || player.name || 'Người chơi';
    return `${holy}${full}`.trim();
  };

  const handleOpenCreateModal = () => {
    if (!currentUser?.id) return;
    setRoomNameInput(`Bàn của ${getPlayerName(currentUser)}`);
    setPasswordInput('');
    setShowCreateModal(true);
  };

  const handleSubmitCreate = (e) => {
    e.preventDefault();
    if (!roomNameInput.trim()) return;
    onCreateRoom(roomNameInput.trim(), passwordInput.trim());
    setShowCreateModal(false);
  };

  const handleJoinClick = (room) => {
    if (room.hasPassword) {
      setTargetPassRoom(room);
      setJoinPasswordInput('');
    } else {
      onJoinRoom(room.id, '');
    }
  };

  const handleSubmitPass = (e) => {
    e.preventDefault();
    if (targetPassRoom) {
      onJoinRoom(targetPassRoom.id, joinPasswordInput);
      setTargetPassRoom(null);
    }
  };

  const handleSelectBotDifficulty = (difficulty) => {
    setShowBotModal(false);
    onPlayWithBot(difficulty);
  };

  const filteredRooms = rooms.filter((r) => {
    if (filter === 'waiting') return r.status === 'waiting';
    if (filter === 'playing') return r.status === 'playing';
    return true;
  });

  return (
    <div className="oanquan-lobby-container">
      {/* Thanh quay về Cổng */}
      <div className="oanquan-lobby-top-bar">
        <button className="oanquan-lobby-back-btn" onClick={onBackToPortal}>
          ⬅️ Về Danh Mục Game
        </button>
        <span className="oanquan-lobby-title-pill">🪨🌾 Sảnh Cờ Ô Ăn Quan</span>
      </div>

      {/* Toolbar công cụ */}
      <div className="oanquan-lobby-toolbar">
        <div className="oanquan-actions-group">
          <button className="oanquan-btn-action create" onClick={handleOpenCreateModal}>
            ➕ Tạo Bàn Mới
          </button>
          <button className="oanquan-btn-action quick" onClick={onQuickMatch}>
            ⚡ Ghép Nhanh
          </button>
          <button className="oanquan-btn-action bot" onClick={() => setShowBotModal(true)}>
            🤖 Đấu Với Máy
          </button>
        </div>

        <div className="oanquan-filter-tabs">
          <button
            className={`oanquan-tab-pill ${filter === 'all' ? 'active' : ''}`}
            onClick={() => setFilter('all')}
          >
            Tất cả ({rooms.length})
          </button>
          <button
            className={`oanquan-tab-pill ${filter === 'waiting' ? 'active' : ''}`}
            onClick={() => setFilter('waiting')}
          >
            Đang chờ ({rooms.filter((r) => r.status === 'waiting').length})
          </button>
          <button
            className={`oanquan-tab-pill ${filter === 'playing' ? 'active' : ''}`}
            onClick={() => setFilter('playing')}
          >
            Đang chơi ({rooms.filter((r) => r.status === 'playing').length})
          </button>
        </div>
      </div>

      {errorMessage && (
        <div className="oanquan-error-banner">
          ⚠️ {errorMessage}
          <button onClick={onClearError}>✕</button>
        </div>
      )}

      {/* Danh sách phòng */}
      <div className="oanquan-room-grid">
        {isLoading ? (
          <div className="oanquan-loading">Đang tải danh sách bàn cờ... ⏳</div>
        ) : filteredRooms.length === 0 ? (
          <div className="oanquan-empty-state">
            <span className="oanquan-empty-icon">🎲</span>
            <p>Chưa có bàn chơi nào. Hãy bấm <b>Tạo Bàn Mới</b> để rủ bạn bè cùng so tài!</p>
          </div>
        ) : (
          filteredRooms.map((room) => {
            const isFull = Boolean(room.player2);
            return (
              <div key={room.id} className="oanquan-room-card">
                <div className="oanquan-card-top">
                  <div className="oanquan-card-title">
                    <h4>{room.name}</h4>
                    {room.hasPassword && <span title="Có mật khẩu">🔒</span>}
                  </div>
                  <span className={`oanquan-status-badge ${room.status}`}>
                    {room.status === 'waiting' ? 'Đang chờ 1/2' : 'Đang đấu 2/2'}
                  </span>
                </div>

                <div className="oanquan-card-players">
                  <div className="oanquan-player-tag">
                    <span>{room.player1?.avatar || '👤'}</span>
                    <span className="oanquan-player-name">{getPlayerName(room.player1)}</span>
                  </div>
                  <span className="oanquan-vs-mini">vs</span>
                  <div className="oanquan-player-tag">
                    <span>{room.player2 ? (room.player2.avatar || '👤') : '❓'}</span>
                    <span className="oanquan-player-name">
                      {room.player2 ? getPlayerName(room.player2) : 'Chờ đối thủ'}
                    </span>
                  </div>
                </div>

                <button
                  className="oanquan-btn-join"
                  disabled={isFull && room.player1?.id !== currentUser?.id && room.player2?.id !== currentUser?.id}
                  onClick={() => handleJoinClick(room)}
                >
                  {room.player1?.id === currentUser?.id || room.player2?.id === currentUser?.id
                    ? 'Vào Lại Bàn'
                    : isFull
                    ? 'Đã Đầy'
                    : 'Vào Chơi ⚔️'}
                </button>
              </div>
            );
          })
        )}
      </div>

      {/* Modal Chọn Cấp Độ Bot AI */}
      {showBotModal && (
        <div className="caro-modal-overlay">
          <div className="caro-modal-box">
            <h3>🤖 Chọn Cấp Độ Ô Ăn Quan</h3>
            <p>Chọn trình độ AI phù hợp với bạn để bắt đầu ván đấu:</p>

            <div className="caro-difficulty-grid">
              <button
                className="caro-diff-btn easy"
                onClick={() => handleSelectBotDifficulty('easy')}
              >
                <span className="caro-diff-icon">🌱</span>
                <div className="caro-diff-meta">
                  <strong>Cấp Độ: Dễ (Tập Sự)</strong>
                  <small>AI cơ bản, phù hợp cho người mới làm quen</small>
                </div>
              </button>

              <button
                className="caro-diff-btn medium"
                onClick={() => handleSelectBotDifficulty('medium')}
              >
                <span className="caro-diff-icon">⚔️</span>
                <div className="caro-diff-meta">
                  <strong>Cấp Độ: Trung Bình (Thử Thách)</strong>
                  <small>Tính toán ăn nhiều sỏi nhất trong lượt đi</small>
                </div>
              </button>

              <button
                className="caro-diff-btn hard"
                onClick={() => handleSelectBotDifficulty('hard')}
              >
                <span className="caro-diff-icon">👑</span>
                <div className="caro-diff-meta">
                  <strong>Cấp Độ: Khó (Cao Thủ)</strong>
                  <small>Đoán trước nước cản và tránh hớ sỏi cho đối thủ</small>
                </div>
              </button>
            </div>

            <div className="caro-modal-actions">
              <button
                type="button"
                className="caro-modal-cancel"
                onClick={() => setShowBotModal(false)}
              >
                Đóng
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Tạo Bàn */}
      {showCreateModal && (
        <div className="caro-modal-overlay">
          <div className="caro-modal-box">
            <h3>✨ Tạo Bàn Ô Ăn Quan</h3>
            <p>Đặt tên và mật khẩu (nếu muốn chơi riêng tư):</p>
            <form onSubmit={handleSubmitCreate} className="caro-modal-form">
              <div>
                <label>Tên bàn đấu:</label>
                <input
                  type="text"
                  value={roomNameInput}
                  onChange={(e) => setRoomNameInput(e.target.value)}
                  placeholder="Nhập tên bàn..."
                  className="caro-modal-input"
                  required
                />
              </div>

              <div>
                <label>Mật khẩu (để trống nếu công khai):</label>
                <input
                  type="password"
                  value={passwordInput}
                  onChange={(e) => setPasswordInput(e.target.value)}
                  placeholder="Mật khẩu..."
                  className="caro-modal-input"
                />
              </div>

              <div className="caro-modal-actions">
                <button
                  type="button"
                  className="caro-modal-cancel"
                  onClick={() => setShowCreateModal(false)}
                >
                  Hủy
                </button>
                <button type="submit" className="caro-modal-submit">
                  Tạo Bàn 🚀
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal Nhập Mật Khẩu */}
      {targetPassRoom && (
        <div className="caro-modal-overlay">
          <div className="caro-modal-box">
            <h3>🔒 Bàn Chơi Có Mật Khẩu</h3>
            <p>Nhập mật khẩu để vào: <b>{targetPassRoom.name}</b></p>
            <form onSubmit={handleSubmitPass} className="caro-modal-form">
              <div>
                <input
                  type="password"
                  value={joinPasswordInput}
                  onChange={(e) => setJoinPasswordInput(e.target.value)}
                  placeholder="Nhập mật khẩu bàn..."
                  className="caro-modal-input"
                  autoFocus
                  required
                />
              </div>

              <div className="caro-modal-actions">
                <button
                  type="button"
                  className="caro-modal-cancel"
                  onClick={() => setTargetPassRoom(null)}
                >
                  Hủy
                </button>
                <button type="submit" className="caro-modal-submit">
                  Vào Bàn 🚀
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default OAnQuanLobby;